export class Customer {
  id: number;
  title: any;
  name: string;
  surname: string;
  language: any;
  country: any; //number | boolean
  countryName: string;
  dial: any;
  phone: string;
  accomodation: any;
  room: any;
  email: any;
  sendEmailCopy: boolean;
  isSpecialAssistanceRequired: boolean;
  specialAssistanceNote: any;
  bookingAnswer?: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/customer.ts